import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { LineupStatusType, ProfileType, BookingStatusType, BookingType } from "../../types/enum";
import { legalEntityHasSuper } from "../../helper/legalEntityHelper";
import superCalculationHelper from "../../helper/superCalculationHelper"
import ConfirmationModalCheckboxComponent from "../modal/ConfirmationModalCheckboxComponent";
// import NumberFormat from "react-number-format";
import {
    Grid,
    Typography,
    Button,
    Card,
    Avatar,
    IconButton,
    CardMedia,
    CardContent,
    CardActions,
    Collapse,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Checkbox,
    TextField,
    InputAdornment,
    Tooltip
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import "./BookingLineup.css";
import "./Lineup/BookingLineupCards.css";
import LineupMessage from "./Lineup/LineupMessage";
import PlayerCard from "./Lineup/PlayerCard";
import ActAdminCard from "./Lineup/ActAdminCard";
import AddPlayerCard from "./Lineup/AddPlayerCard";
import FeeSummaryPanel from "./Lineup/FeeSummaryPanel";

import moment from "moment";
import ResponsiveTable from "../table/ResponsiveTable";
import NewLineupModal from "./Lineup/NewLineupModal";
import RedirectLineUpModal from "./Lineup/redirectLineUpModal"
import ConfirmationModal from "../modal/ConfirmationModal";
import image from "../../helper/image";
import Loading from "../loadingSpinner/Loading";
import SaveButtonCard from "./Lineup/SaveButtonCard";
import UnifiedLineupTable from "./Lineup/UnifiedLineupTable";

const SHOW_PRODUCTION_CREW = process.env.REACT_APP_SHOW_PRODUCTION_CREW === "true";
// Feature flag for new card-based lineup UI - set to true to enable, false for original table layout
const USE_NEW_LINEUP_UI = true;
// Feature flag for unified table UI - set to true for unified table, false for cards layout
const USE_UNIFIED_TABLE_UI = true;

@inject("lineupStore", "bookingRequestStore", "templateStore", "profileStore")
@observer
class BookingLineup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelBookingModalState: false,
            declineBookingModalState: false,
            showNewLineupModal: false,
            showRemoveLineupConfirmation: false,
            deletedLineup: undefined,
            showRedirectModal: false,
            unsaveFees: false,
            showRedirectPromote: false,
            closeReminder: false,
            showNavigationModal: false,
            pendingLocation: null,
            navigationMessage: ""
        };
        this.unblockNavigation = null;
    }

    componentDidMount() {
        Promise.all([this.props.lineupStore.load(this.props.bookingId), this.props.bookingRequestStore.load(this.props.bookingId)]).then(res => {
            this.props.bookingRequestStore.getPlayerSuperFeePercentage()
        });

        this.unblockNavigation = this.props.history.block((location) => {
            const { lineUpBlock } = this.props.templateStore;
            const { unsaveFees } = this.state;
            
            if (lineUpBlock) {
                this.setState({
                    showNavigationModal: true,
                    pendingLocation: location,
                    navigationMessage: "You have unsaved lineup changes. Do you still want to leave this section?"
                });
                return false;
            }
            
            if (unsaveFees) {
                this.setState({
                    showNavigationModal: true,
                    pendingLocation: location,
                    navigationMessage: "You have not saved your updated fees. Do you want to continue?"
                });
                return false;
            }
            
            return true;
        });
    }

    componentWillUnmount() {
        if (this.unblockNavigation) {
            this.unblockNavigation();
        }
    }

    isActOwnerLineup = lineup => {
        const { booking } = this.props.bookingRequestStore;
        const actAdminId = booking?.act?.actAdminId;

        return (
            lineup?.profileId !== undefined &&
            lineup?.profileId !== null &&
            actAdminId !== undefined &&
            actAdminId !== null &&
            String(lineup.profileId) === String(actAdminId)
        );
    };

    shouldExcludeActOwnerPlayer = lineup => {
        const { booking } = this.props.bookingRequestStore;
        return Boolean(booking?.isPayByActOwner && this.isActOwnerLineup(lineup));
    };

    handleNavigationConfirm = () => {
        const { pendingLocation } = this.state;
        
        if (this.unblockNavigation) {
            this.unblockNavigation();
        }
        
        this.setState({
            showNavigationModal: false,
            pendingLocation: null,
            navigationMessage: "",
            unsaveFees: false
        }, () => {
            this.props.templateStore.closeLineupBlock();
            if (pendingLocation) {
                this.props.history.push(pendingLocation.pathname + (pendingLocation.search || ""));
            }
        });
    }

    handleNavigationCancel = () => {
        this.setState({
            showNavigationModal: false,
            pendingLocation: null,
            navigationMessage: ""
        });
    }

    handleExpandClick = instrument => {
        this.props.lineupStore.setExpand(instrument);
        this.setState({ ...this.state });
    };

    handleSelectPlayer = (instrument, player) => {
        this.props.lineupStore.setPlayer(instrument, player);
    };

    handleSetManualRosterFee = (fee, index) => {
        if (!fee) {
            fee = 0;
        }
        fee = fee == 0 ? 0 : fee.replace(/[^0-9.,]+/g,'').replace(/[,]/,'.')
        this.props.lineupStore.setManualLineupFee(fee, index);
        this.setState({
            ...this.state
        });
    };

    handleSubmitForm = e => {
        const { booking } = this.props.bookingRequestStore;

        this.setState({ ...this.state, unsaveFees: false });
        const { type, isBookingCreator} = this.props.bookingRequestStore.booking;
        e.preventDefault();
        this.props.templateStore.showLoadingScreen();
        this.props.templateStore.openLineupBlock();
        // submit
        return this.props.lineupStore.submit(booking).then(
            () => {
                this.props.templateStore.openSnackbar("Lineup Saved");
                this.props.templateStore.hideLoadingScreen();
                if(type == BookingType.Adhoc.ordinal && isBookingCreator){
                    this.showRedirectLineUpModal()
                }else{
                    this.showRedirectPromoteModal()
                }
                
                // this.props.templateStore.setEditMusicianBookingActiveStep(3);
            },
            err => {
                this.props.templateStore.hideLoadingScreen();
                this.setState({ unsaveFees: true });
                this.props.templateStore.openSnackbar(
                    typeof err === "string" ? err : err?.message || "Could not save lineup. Please try again."
                );
            }
        );
    };

    statusText = (lineup, id, oldLineup) => {
        let currentProfile = this.props.profileStore.getCurrentProfile();
        var value = lineup.status
        var isInvited = id ? true : false;
        switch (value) {
            case LineupStatusType.New.ordinal: {
                if (isInvited && oldLineup) {
                    return "Invited";
                }
                else {
                    if(currentProfile?.id === lineup.profileId){
                        return "Accepted";
                    }else{
                        return "Not Yet Invited";
                    }
                  
                }
            }
            case LineupStatusType.Declined.ordinal:
                return "Declined";
            case LineupStatusType.Hold.ordinal:
                return "Hold";
            case LineupStatusType.Accepted.ordinal:
                return "Accepted";
            case LineupStatusType.Confirmed.ordinal:
                return "Confirmed";
            case LineupStatusType.Cancelled.ordinal:
            case LineupStatusType.Removed.ordinal:
                return "Cancelled";
            default:
                {
                    if (isInvited) {
                        return "Invited";
                    }
                    else {
                        return "Not Yet Invited";
                    }
                }
        }
    };

    isLineupSaveButtonDisabled = () => {
        const { actFee } = this.props.bookingRequestStore.booking;
        const { lineups } = this.props.lineupStore;
        const { booking } = this.props.bookingRequestStore;

        let sumFee = 0;

        var performanceFee = 0
        if(booking.isPayByActOwner && booking.isSuperFee){
            
            performanceFee = parseFloat(booking?.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee).toFixed(2)

        }else{
            performanceFee = booking.actFee
        }


        lineups.forEach(lineup => {
            if (lineup.status !== LineupStatusType.Removed.ordinal && !this.isActOwnerLineup(lineup)) {
                sumFee += Number(lineup.manualFee) === 0 ? Number(lineup.manualFee) : Number(lineup.manualFee) ? Number(lineup.manualFee) : Number(lineup.fee);
            }
        });

        if (sumFee > Number(performanceFee)) {
            return true;
        } else {
            return false;
        }
    };

    changeLineupEditMode = index => {
        this.props.lineupStore.toggleLineupEditMode(index);
        this.setState({ ...this.state});
    };

    doneLineupFeeEdit = index => {
        this.props.templateStore.closeLineupBlock();
        this.props.lineupStore.doneEditLineupFeeChanges(index);
        this.setState({ ...this.state, unsaveFees: true });
    };

    
    getLineupExtraGigFee = () => {
        const { lineups } = this.props.lineupStore;

        const { booking } = this.props.bookingRequestStore;
        const eligibleLineups = booking.isPayByActOwner
            ? lineups.filter(lineup => !this.isActOwnerLineup(lineup))
            : lineups;

        return booking.extraGigFeeApprovalById && booking.extraGigFee && booking.extraGigFee > 0 && eligibleLineups.length > 0
            ? parseFloat(booking.extraGigFee / eligibleLineups.length).toFixed(2)
            : 0;
    };

    getLineupColumns = () => {
        const { booking } = this.props.bookingRequestStore;
        let lineupColumns = [
            { key: "instruments", label: "Instruments", width: "30%" },
            { key: "player", label: "Player Name", width: "20%" },
            { key: "fee", label: booking.extraGigFee && booking.extraGigFee > 0 ? `Player Fee (+ Extra Gig Fee)` : "Player Fee", width: "15%" },
            { key: "superFee", label: "Super Fee", width: "10%" },
            { key: "invoiceAmount", label: "Invoice Amount", width: "10%" },
            { key: "editFeeButton", label: "", width: "10%" }
        ];

        return lineupColumns;
    };

     getFeeColumns = () => {
        const { booking } = this.props.bookingRequestStore;
        let lineupColumns = [
            { key: "actName", label: "Act Name", width: "30%" },
            { key: "actAdmin", label: "Act Admin", width: "20%" },
            { key: "fee", label: "Performance Fee", width: "15%" },
            { key: "superFee", label: "Super Fee", width: "10%" },
            { key: "invoiceAmount", label: "Invoice Amount", width: "10%" },
            { key: "editFeeButton", label: "", width: "10%" }
        ];

        return lineupColumns;
    };


    

    getFeeRow = () => {
        const { lineups } = this.props.lineupStore;
        const { currentProfile } = this.props.profileStore;
        let rows = [];
        const { status } = this.props.bookingRequestStore.booking;
        const { booking, percentageFeeSuper } = this.props.bookingRequestStore;
       
            var superFee = booking.includeSuper ? superCalculationHelper.calculateSuperWithInclude(booking.actFee,booking.percentageFeeSuper) : superCalculationHelper.calculateSuperWithExclude(booking.actFee,booking.percentageFeeSuper)
            var invoiceAmount = booking.includeSuper ? parseFloat(parseFloat(booking.actFee) - parseFloat(superFee)).toFixed(2) : parseFloat(booking.actFee).toFixed(2)
           
            rows.push({
                actName: booking && booking.act && booking.act?.actName ? booking.act?.actName : "-",
                actAdmin: `${currentProfile?.firstName}  ${currentProfile?.lastName}`,
                fee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${booking.actFee}`,
                superFee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${superFee}`,
                invoiceAmount:`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${invoiceAmount}`
            });

            return rows;
        
    }


    getLineupRowsPayActOwner = () => {
        
        const { lineups } = this.props.lineupStore;
        const { currentProfile } = this.props.profileStore;
        let rows = [];
        const { status } = this.props.bookingRequestStore.booking;
        const { booking, percentageFeeSuper, act } = this.props.bookingRequestStore;
        var performanceFee = 0
        // if(booking.isPayByActOwner){
        //     performanceFee = parseFloat(booking?.includeSuper ? parseFloat(booking.actFee)-(parseFloat(booking.percentageFeeSuper) * parseFloat(booking.actFee)/100) : booking.actFee).toFixed(2)
        // }else{
        //     performanceFee = parseFloat(booking?.includeSuper ? parseFloat(booking.actFee) : parseFloat(booking.actFee) + (parseFloat(booking.percentageFeeSuper) * parseFloat(booking.actFee)/100)).toFixed(2)
        // }
        var performanceFee = 0
        var superFeeExclude = false
        if(booking.isPayByActOwner && booking.isSuperFee){
            performanceFee = parseFloat(booking?.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee).toFixed(2)
            superFeeExclude = !booking?.includeSuper
        }else{
            performanceFee = booking.actFee
            superFeeExclude = !booking?.includeSuper
        }
        let totalFee = 0;
        lineups.forEach(lineup => {
            if (lineup.status !== LineupStatusType.Removed.ordinal) {
                totalFee += lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? Number(lineup.manualFee) : Number(lineup.fee);
            }
        });

        lineups.forEach((lineup, index) => {
            const playerExtraGigFee = this.getLineupExtraGigFee(index);
            const playerExtraGigFeeString =
                playerExtraGigFee > 0
                    ? `    (+ ${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${playerExtraGigFee})`
                    : "";
            var lineupFee = parseFloat(lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? (lineup.manualFee) : (lineup.fee))
            var superFee = 0;
            var invoiceAmountLineup = 0
            if(!booking.isPayByActOwner && !booking.includeSuper) {
                superFee = superCalculationHelper.calculateSuperWithExclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper)
                invoiceAmountLineup = lineupFee
            }else{
                superFee = superCalculationHelper.calculateSuperWithInclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper) 
                if(booking.isPayByActOwner || booking.includeSuper){
                    invoiceAmountLineup = parseFloat(lineupFee - (legalEntityHasSuper(lineup?.profile?.legalEntity) ? superFee : 0)).toFixed(2)
                }else{
                    invoiceAmountLineup = parseFloat(lineupFee).toFixed(2)
                }
                
            }
            if(this.isActOwnerLineup(lineup) && booking.isPayByActOwner ){
                invoiceAmountLineup = parseFloat(lineupFee).toFixed(2)
                superFee = 0
            }
            if (lineup.status !== LineupStatusType.Removed.ordinal && !this.isActOwnerLineup(lineup)) {
                rows.push({
                    superFee: legalEntityHasSuper(lineup?.profile?.legalEntity) ? currentProfile?.id === lineup?.profile?.id ?`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${superFee}` : `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${superFee}` : "-",
                    invoiceAmount: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${invoiceAmountLineup}`,
                    instruments: lineup.name,
                    player: lineup.profile ? `${lineup.profile.firstName} ${lineup.profile.lastName}` : "",
                    fee: lineup.editMode ? (
                        <TextField
                            value={lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? (lineup.manualFee) : (lineup.fee)}
                            fullWidth
                            onChange={e => this.handleSetManualRosterFee(e.target.value, index)}
                            type="string"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"}`}
                                    </InputAdornment>
                                )
                            }}
                        />
                    ) : (
                        `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(lineup.fee).toFixed(2)
                        }${playerExtraGigFeeString}`
                    ),
                    editFeeButton: lineup.editMode ? (
                        <Fragment>
                            <Button style={{ marginRight: "8px" }} variant="raised" color="primary" onClick={ (status === BookingStatusType.Completed.ordinal) ? () => this.doneLineupFeeEdit(index) : () => this.doneLineupFeeEdit(index)}>
                                Done
                            </Button>
                            <Button variant="outlined" onClick={() => this.changeLineupEditMode(index)}>
                                Cancel
                            </Button>
                        </Fragment>
                    ) : (
                        <Button variant="raised" color="primary" onClick={() => this.changeLineupEditMode(index)}>
                            Edit
                        </Button>
                    )
                });
            }
        });
        // var adminFee = isNaN(totalFee) ? performanceFee : parseFloat(performanceFee - totalFee).toFixed(2)
        // var superFeeAdmin = 0
        // if(booking.isSuperFee && !booking.isPayByActOwner){
        //     if(!booking.isPayByActOwner && !booking.includeSuper) {
        //         superFeeAdmin = superCalculationHelper.calculateSuperWithExclude(adminFee, booking.percentageFeeSuper)
        //     }else{
        //         superFeeAdmin = superCalculationHelper.calculateSuperWithInclude(adminFee, booking.percentageFeeSuper)
        //     }

        // }

    
    
        // var invoiceAmount = parseFloat(adminFee - (superFeeExclude ? 0 : superFeeAdmin)).toFixed(2)
        // rows.unshift({
        //     instruments: "-",
        //     player: `${currentProfile?.firstName}  ${currentProfile?.lastName} (Act Admin)`,
        //     fee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${adminFee}`,
        //     superFee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${superFeeAdmin}`,
        //     invoiceAmount:`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${invoiceAmount}`
        // });

    
        

        return rows;
    };

    getLineupFooterRowsPayActOwner = () => {
        const { lineups } = this.props.lineupStore;
        const { booking, percentageFeeSuper, act } = this.props.bookingRequestStore;
        const { currentProfile } = this.props.profileStore;
        let extraGigFee =
            booking.extraGigFee && booking.extraGigFee > 0
                ? `    (+ ${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${booking.extraGigFee})`
                : "";
        
         var performanceFee = 0
        var superFeeExclude = false
        
        if(booking.isPayByActOwner && booking.isSuperFee){
            
            performanceFee = parseFloat(booking?.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee).toFixed(2)
            superFeeExclude = !booking?.includeSuper
        }else{
            performanceFee = booking.actFee
            superFeeExclude = !booking?.includeSuper
        }

        let totalFee = 0;

         var filtedLineup = lineups.filter(x=>x.status !== LineupStatusType.Removed.ordinal)
        var isSoloAdminLineup = false
        if(booking.isPayByActOwner && booking?.act?.actAdminId == currentProfile?.id){
            if(!filtedLineup || !filtedLineup.length){
                isSoloAdminLineup = true
            }else if(filtedLineup.length > 2){
                isSoloAdminLineup = false
            }
            else if(filtedLineup.length == 1){
                isSoloAdminLineup = filtedLineup[0].profileId === currentProfile?.id
            }
        }
        if(isSoloAdminLineup){
            var superFee = booking.includeSuper ? superCalculationHelper.calculateSuperWithInclude(booking.actFee,booking.percentageFeeSuper) : superCalculationHelper.calculateSuperWithExclude(booking.actFee,booking.percentageFeeSuper)
            var invoiceAmount = parseFloat(parseFloat(booking.actFee) - parseFloat(superFee)).toFixed(2)
        
            return {
            player: "Total split among lineups",
            fee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(booking.actFee).toFixed(2)}`,
            invoiceAmount: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(invoiceAmount).toFixed(2)}`,
            superFee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(superFee).toFixed(2)}`,
            style: {
                backgroundColor: "#EEEEEE",
                fontWeight: "bold"
            }
        };
        }
       
        lineups.forEach(lineup => {
            if (lineup.status !== LineupStatusType.Removed.ordinal) {
                totalFee += lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? Number(lineup.manualFee) : Number(lineup.fee);
            }
        });

        var totalLineupFee = 0
        var sumInvoiceLineup = 0
        var sumSuper = 0
          lineups.forEach((lineup, index) => {
            if(this.isActOwnerLineup(lineup) || lineup.status == LineupStatusType.Removed.ordinal) return
            const playerExtraGigFee = this.getLineupExtraGigFee(index);
            const playerExtraGigFeeString =
                playerExtraGigFee > 0
                    ? `    (+ ${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${playerExtraGigFee})`
                    : "";
            var lineupFee = parseFloat(lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? (lineup.manualFee) : (lineup.fee))
            var superFee = 0;
            var invoiceAmountLineup = 0
            if(!booking.isPayByActOwner && !booking.includeSuper) {
                superFee = superCalculationHelper.calculateSuperWithExclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper)
                invoiceAmountLineup = lineupFee
            }else{
                superFee = superCalculationHelper.calculateSuperWithInclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper) 
                invoiceAmountLineup = parseFloat(lineupFee - (legalEntityHasSuper(lineup?.profile?.legalEntity) ? superFee : 0)).toFixed(2)
            }
            
            
            if(this.isActOwnerLineup(lineup) && booking.isPayByActOwner ){
                sumInvoiceLineup = sumInvoiceLineup + parseFloat(lineupFee)
            }else{
                sumInvoiceLineup = sumInvoiceLineup + parseFloat(invoiceAmountLineup)
                sumSuper = sumSuper + (legalEntityHasSuper(lineup?.profile?.legalEntity)?  parseFloat(superFee) : 0 )
            }
            totalLineupFee += parseFloat(lineup.fee)
        });

        // var adminFee = isNaN(totalFee) ? performanceFee : parseFloat(performanceFee - totalFee).toFixed(2)
        // var superFeeAdmin = 0
       

        // if(booking.isSuperFee && !booking.isPayByActOwner){
        //     if(!booking.isPayByActOwner && !booking.includeSuper) {
        //         superFeeAdmin = superCalculationHelper.calculateSuperWithExclude(adminFee, booking.percentageFeeSuper)
        //     }else{
        //         superFeeAdmin = superCalculationHelper.calculateSuperWithInclude(adminFee, booking.percentageFeeSuper)
        //     }

        // }

        
        // var invoiceAmount = parseFloat(adminFee - (superFeeExclude ? 0 : superFeeAdmin)).toFixed(2)
        // sumInvoiceLineup = sumInvoiceLineup + + parseFloat(invoiceAmount)
        // sumSuper = sumSuper + parseFloat(superFeeAdmin)
        return {
            player: "Total",
            fee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(totalLineupFee).toFixed(2)}`,
            invoiceAmount: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(sumInvoiceLineup).toFixed(2)}`,
            superFee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(sumSuper).toFixed(2)}`,
            style: {
                backgroundColor: "#EEEEEE",
                fontWeight: "bold"
            }
        };
    };

     getLineupRows = () => {
        
        const { lineups } = this.props.lineupStore;
        const { currentProfile } = this.props.profileStore;
        let rows = [];
        const { status } = this.props.bookingRequestStore.booking;
        const { booking, percentageFeeSuper, act } = this.props.bookingRequestStore;
        var performanceFee = 0
        // if(booking.isPayByActOwner){
        //     performanceFee = parseFloat(booking?.includeSuper ? parseFloat(booking.actFee)-(parseFloat(booking.percentageFeeSuper) * parseFloat(booking.actFee)/100) : booking.actFee).toFixed(2)
        // }else{
        //     performanceFee = parseFloat(booking?.includeSuper ? parseFloat(booking.actFee) : parseFloat(booking.actFee) + (parseFloat(booking.percentageFeeSuper) * parseFloat(booking.actFee)/100)).toFixed(2)
        // }
        var performanceFee = 0
        var superFeeExclude = false
        if(booking.isPayByActOwner && booking.isSuperFee){
            
            performanceFee = parseFloat(booking?.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee).toFixed(2)
            superFeeExclude = !booking?.includeSuper
        }else{
            performanceFee = booking.actFee
            superFeeExclude = !booking?.includeSuper
        }
        let totalFee = 0;
       
        lineups.forEach(lineup => {
            if (lineup.status !== LineupStatusType.Removed.ordinal) {
                totalFee += lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? Number(lineup.manualFee) : Number(lineup.fee);
            }
        });

        lineups.forEach((lineup, index) => {
            const playerExtraGigFee = this.getLineupExtraGigFee(index);
            const playerExtraGigFeeString =
                playerExtraGigFee > 0
                    ? `    (+ ${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${playerExtraGigFee})`
                    : "";
            var lineupFee = parseFloat(lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? (lineup.manualFee) : (lineup.fee))
            var superFee = 0;
            var invoiceAmountLineup = 0
            if(!booking.isPayByActOwner && !booking.includeSuper) {
                superFee = superCalculationHelper.calculateSuperWithExclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper)
                invoiceAmountLineup = lineupFee
            }else{
                superFee = superCalculationHelper.calculateSuperWithInclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper) 
                if(booking.isPayByActOwner || booking.includeSuper){
                    invoiceAmountLineup = parseFloat(lineupFee - (legalEntityHasSuper(lineup?.profile?.legalEntity) ? superFee : 0)).toFixed(2)
                }else{
                    invoiceAmountLineup = parseFloat(lineupFee).toFixed(2)
                }
                
            }
             if(this.isActOwnerLineup(lineup) && booking.isPayByActOwner ){
                invoiceAmountLineup = parseFloat(lineupFee).toFixed(2)
                superFee = 0
             }
            if (lineup.status !== LineupStatusType.Removed.ordinal) {
                rows.push({
                    superFee: legalEntityHasSuper(lineup?.profile?.legalEntity) ? currentProfile?.id === lineup?.profile?.id ?`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${superFee}` : `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${superFee}` : "-",
                    invoiceAmount: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${invoiceAmountLineup}`,
                    instruments: lineup.name,
                    player: lineup.profile ? `${lineup.profile.firstName} ${lineup.profile.lastName}` : "",
                    fee: lineup.editMode ? (
                        <TextField
                            value={lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? (lineup.manualFee) : (lineup.fee)}
                            fullWidth
                            onChange={e => this.handleSetManualRosterFee(e.target.value, index)}
                            type="string"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"}`}
                                    </InputAdornment>
                                )
                            }}
                        />
                    ) : (
                        `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(lineup.fee).toFixed(2)
                        }${playerExtraGigFeeString}`
                    ),
                    editFeeButton: lineup.editMode ? (
                        <Fragment>
                            <Button style={{ marginRight: "8px" }} variant="raised" color="primary" onClick={ (status === BookingStatusType.Completed.ordinal) ? () => this.doneLineupFeeEdit(index) : () => this.doneLineupFeeEdit(index)}>
                                Done
                            </Button>
                            <Button variant="outlined" onClick={() => this.changeLineupEditMode(index)}>
                                Cancel
                            </Button>
                        </Fragment>
                    ) : (
                        <Button variant="raised" color="primary" onClick={() => this.changeLineupEditMode(index)}>
                            Edit
                        </Button>
                    )
                });
            }
        });
        var adminFee = isNaN(totalFee) ? performanceFee : parseFloat(performanceFee - totalFee).toFixed(2)
        var superFeeAdmin = 0
        if(booking.isSuperFee && !booking.isPayByActOwner){
            if(!booking.isPayByActOwner && !booking.includeSuper) {
                superFeeAdmin = superCalculationHelper.calculateSuperWithExclude(adminFee, booking.percentageFeeSuper)
            }else{
                superFeeAdmin = superCalculationHelper.calculateSuperWithInclude(adminFee, booking.percentageFeeSuper)
            }

        }

       
      
        var invoiceAmount = parseFloat(adminFee - (superFeeExclude ? 0 : superFeeAdmin)).toFixed(2)
        rows.unshift({
            instruments: "-",
            player: `${currentProfile?.firstName}  ${currentProfile?.lastName} (Act Admin)`,
            fee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${adminFee}`,
            superFee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${superFeeAdmin}`,
            invoiceAmount:`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${invoiceAmount}`
        });

        return rows;
    };

    getLineupFooterRows = () => {
        const { lineups } = this.props.lineupStore;
        const { booking, percentageFeeSuper, act } = this.props.bookingRequestStore;
        const { currentProfile } = this.props.profileStore;
        let extraGigFee =
            booking.extraGigFee && booking.extraGigFee > 0
                ? `    (+ ${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${booking.extraGigFee})`
                : "";
        
         var performanceFee = 0
        var superFeeExclude = false
        
        if(booking.isPayByActOwner && booking.isSuperFee){
            
            performanceFee = parseFloat(booking?.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee).toFixed(2)
            superFeeExclude = !booking?.includeSuper
        }else{
            performanceFee = booking.actFee
            superFeeExclude = !booking?.includeSuper
        }

        let totalFee = 0;
       
        lineups.forEach(lineup => {
            if (lineup.status !== LineupStatusType.Removed.ordinal) {
                totalFee += lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? Number(lineup.manualFee) : Number(lineup.fee);
            }
        });

        var sumInvoiceLineup = 0
        var sumSuper = 0
          lineups.forEach((lineup, index) => {
            const playerExtraGigFee = this.getLineupExtraGigFee(index);
            const playerExtraGigFeeString =
                playerExtraGigFee > 0
                    ? `    (+ ${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${playerExtraGigFee})`
                    : "";
            var lineupFee = parseFloat(lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? (lineup.manualFee) : (lineup.fee))
            var superFee = 0;
            var invoiceAmountLineup = 0
            if(!booking.isPayByActOwner && !booking.includeSuper) {
                superFee = superCalculationHelper.calculateSuperWithExclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper)
                invoiceAmountLineup = lineupFee
            }else{
                superFee = superCalculationHelper.calculateSuperWithInclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper) 
                invoiceAmountLineup = parseFloat(lineupFee - (legalEntityHasSuper(lineup?.profile?.legalEntity) ? superFee : 0)).toFixed(2)
            }
            
            
            if(this.isActOwnerLineup(lineup) && booking.isPayByActOwner ){
                sumInvoiceLineup = sumInvoiceLineup + parseFloat(lineupFee)
            }else{
                sumInvoiceLineup = sumInvoiceLineup + parseFloat(invoiceAmountLineup)
                sumSuper = sumSuper + (legalEntityHasSuper(lineup?.profile?.legalEntity)?  parseFloat(superFee) : 0 )
            }
        });

        var adminFee = isNaN(totalFee) ? performanceFee : parseFloat(performanceFee - totalFee).toFixed(2)
        var superFeeAdmin = 0
       

        if(booking.isSuperFee && !booking.isPayByActOwner){
            if(!booking.isPayByActOwner && !booking.includeSuper) {
                superFeeAdmin = superCalculationHelper.calculateSuperWithExclude(adminFee, booking.percentageFeeSuper)
            }else{
                superFeeAdmin = superCalculationHelper.calculateSuperWithInclude(adminFee, booking.percentageFeeSuper)
            }

        }

        
        var invoiceAmount = parseFloat(adminFee - (superFeeExclude ? 0 : superFeeAdmin)).toFixed(2)
        sumInvoiceLineup = sumInvoiceLineup + + parseFloat(invoiceAmount)
        sumSuper = sumSuper + parseFloat(superFeeAdmin)
        return {
            player: "Total",
            fee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(performanceFee).toFixed(2)}`,
            invoiceAmount: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(sumInvoiceLineup).toFixed(2)}`,
            superFee: `${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"} ${parseFloat(sumSuper).toFixed(2)}`,
            style: {
                backgroundColor: "#EEEEEE",
                fontWeight: "bold"
            }
        };
    };

    handleRemoveLineup = () => {
        const target = this.state.deletedLineup;
        const { booking } = this.props.bookingRequestStore;
        if (!target?.lineup || target.bookingId !== booking.id ||
            target.profileId !== target.lineup.profileId ||
            !this.props.lineupStore.removeLineup(target.lineup)) {
            this.props.templateStore.openSnackbar("The lineup has changed. Please select the player again.");
        }
        this.hideRemoveLineupConfirmation();
    };

    renderPlayerLineup = (lineup, index) => {
        const { isPayByActOwner, act,isAdmin, status, dateStart, lineups: bookingLineups, actFee } = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        const { lineups } = this.props.lineupStore;
        const lineupsChanged = bookingLineups?.find(x => x.profileId === lineup.profileId);     
        

          var filtedLineup = lineups.filter(x=>x.status !== LineupStatusType.Removed.ordinal)
        var isSoloAdminLineup = false
        if(isPayByActOwner && act?.actAdminId == currentProfile?.id){
            if(!filtedLineup || !filtedLineup.length){
                isSoloAdminLineup = true
            }else if(filtedLineup.length > 2){
                isSoloAdminLineup = false
            }
            else if(filtedLineup.length == 1){
                isSoloAdminLineup = filtedLineup[0].profileId === currentProfile?.id
            }
        }
        return (
            <Grid item xs={12} lg={3} key={lineup.name}>
                <Card className="lineup-card" elevation={1}>
                    <CardMedia
                        image={lineup && lineup.profile ? image.getBackgroundImage(lineup.profile) : ""}
                        title="Background Image"
                        className="card-avatar"
                    >
                        {lineup &&
                            lineup.profile && (
                                <Avatar className="avatar" aria-label={lineup.profile.firstName} src={image.getProfileImage(lineup.profile)} />
                            )}
                    </CardMedia>
                    <CardContent className="detail">
                        {lineup &&
                            lineup.profile && (
                                <Typography variant="title" component="h2">
                                    {lineup.profile.firstName} {lineup.profile.lastName}
                                </Typography>
                            )}
                        {lineup && <Typography variant="caption">{lineup.name}</Typography>}
                        {isAdmin &&
                            lineup && (
                                <Grid container direction="column">
                                    <Grid item>
                                        <Grid container spacing={16} justify="flex-start">
                                            <Grid item xs={6} style={{ textAlign: "left" }}>
                                                {isPayByActOwner && this.isActOwnerLineup(lineup) ? "Performance Fee" : "Fee Amount"}
                                            </Grid>
                        {
                            isPayByActOwner && this.isActOwnerLineup(lineup)  ? <Grid item xs={6} style={{ textAlign: "right" }}>
                                                {`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"
                                                    } ${parseFloat(actFee).toFixed(2)}`}
                                            </Grid> : <Grid item xs={6} style={{ textAlign: "right" }}>
                                                {`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"
                                                    } ${parseFloat(parseFloat(lineup.fee) + parseFloat(this.getLineupExtraGigFee(index))).toFixed(2)}`}
                                            </Grid>
                        }
                                            
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container spacing={16}>
                                            <Grid item xs={6} style={{ textAlign: "left" }}>
                                                Status
                                            </Grid>
                                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                                {this.statusText(lineup, lineup.id, lineupsChanged)}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                    </CardContent>
                    {isAdmin &&
                        lineup && (
                            <CardActions disableActionSpacing className="action">
                                <IconButton
                                    className={lineup.expanded ? "expanderOpen" : "expander"}
                                    onClick={this.handleExpandClick.bind(this, lineup)}
                                    aria-expanded={lineup.expanded}
                                    aria-label="Show more"
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                                
                                <IconButton disabled={status === BookingStatusType.Cancelled.ordinal ||
                                                                status === BookingStatusType.New.ordinal} style={{ marginLeft: "auto", marginRight: 0 }} onClick={() => this.showRemoveLineupConfirmation(lineup)}>
                                    <DeleteIcon />
                                </IconButton>
                            </CardActions>
                        )}
                    {isAdmin &&
                        lineup &&
                        lineup.actRoster &&
                        lineup.actRoster.rosters && (
                            <Collapse in={lineup.expanded} timeout="auto">
                                <CardContent className="list">
                                    <Typography gutterBottom>Select player:</Typography>
                                    <List>
                                        {lineup &&
                                            lineup.actRoster &&
                                            lineup.actRoster.rosters
                                                .filter(p =>
                                                    !(
                                                        isPayByActOwner &&
                                                        p?.profile &&
                                                        this.isActOwnerLineup({ profileId: p.profile.id })
                                                    )
                                                )
                                                .map(
                                                p =>
                                                    p && p.profile ? (
                                                        <ListItem
                                                            key={p.id}
                                                            dense
                                                            button
                                                            className="player-listitem"
                                                            onClick={this.handleSelectPlayer.bind(this, lineup, p)}
                                                            disabled={
                                                                status === BookingStatusType.Cancelled.ordinal ||
                                                                status === BookingStatusType.New.ordinal ||
                                                                !p.available ||
                                                                lineups.filter(x => x.profileId === p.profile.id).length > 0
                                                            }
                                                        >
                                                            {p.profile && (
                                                                <Avatar aria-label={p.profile.firstName} src={image.getProfileImage(p.profile)} />
                                                            )}

                                                            {p.profile && (
                                                                <ListItemText
                                                                    primary={`${p.profile.firstName} ${p.profile.lastName}`}
                                                                    secondary={p.available ? "Available" : "Unavailable"}
                                                                />
                                                            )}
                                                            <ListItemSecondaryAction>
                                                                <Checkbox
                                                                    onChange={this.handleSelectPlayer.bind(this, lineup, p)}
                                                                    checked={p.profileId === lineup.profileId}
                                                                    disabled={
                                                                        status === BookingStatusType.Cancelled.ordinal ||
                                                                        status === BookingStatusType.New.ordinal ||
                                                                        !p.available ||
                                                                        lineups.filter(x => x.profileId === p.profile.id).length > 0
                                                                    }
                                                                />
                                                            </ListItemSecondaryAction>
                                                        </ListItem>
                                                    ) : (
                                                        ""
                                                    )
                                            )}
                                    </List>
                                </CardContent>
                            </Collapse>
                        )}
                </Card>
            </Grid>
        );
    };

    renderProductionLineup = (lineup, index) => {
        const { isAdmin, status, dateStart } = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        return (
            <Grid item xs={12} lg={3} key={lineup.name}>
                <Card className="lineup-card" elevation={1}>
                    <CardMedia
                        image={lineup && lineup.profile ? image.getBackgroundImage(lineup.profile) : ""}
                        title="Background Image"
                        className="card-avatar"
                    >
                        {lineup &&
                            lineup.profile && (
                                <Avatar className="avatar" aria-label={lineup.profile.firstName} src={image.getBackgroundImage(lineup.profile)} />
                            )}
                    </CardMedia>
                    <CardContent className="detail">
                        {lineup &&
                            lineup.profile && (
                                <Typography variant="title" component="h2">
                                    {lineup.profile.firstName} {lineup.profile.lastName}
                                </Typography>
                            )}
                        {lineup && <Typography variant="caption">{lineup.name}</Typography>}
                        {isAdmin &&
                            lineup && (
                                <Grid container direction="column">
                                    <Grid item>
                                        <Grid container spacing={16} justify="flex-start">
                                            <Grid item xs={6} style={{ textAlign: "left" }}>
                                                Fee Amount
                                            </Grid>
                                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                                {`${currentProfile && currentProfile?.currencySymbol ? currentProfile?.currencySymbol : "$"
                                                    } ${parseFloat(lineup.fee) + parseFloat(this.getLineupExtraGigFee(index))}`}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container spacing={16}>
                                            <Grid item xs={6} style={{ textAlign: "left" }}>
                                                Status
                                            </Grid>
                                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                                {this.statusText(lineup)}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                    </CardContent>
                    {isAdmin &&
                        lineup && (
                            <CardActions disableActionSpacing className="action">
                                <IconButton
                                    className={lineup.expanded ? "expanderOpen" : "expander"}
                                    onClick={this.handleExpandClick.bind(this, lineup)}
                                    aria-expanded={lineup.expanded}
                                    aria-label="Show more"
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                            </CardActions>
                        )}
                    {isAdmin &&
                        lineup &&
                        lineup.actRoster &&
                        lineup.actRoster.productionRosters && (
                            <Collapse in={lineup.expanded} timeout="auto">
                                <CardContent className="list">
                                    <Typography gutterBottom>Select player:</Typography>
                                    <List>
                                        {lineup &&
                                            lineup.actRoster &&
                                            lineup.actRoster.productionRosters.map(
                                                p =>
                                                    p && p.profile ? (
                                                        <ListItem
                                                            key={p.id}
                                                            dense
                                                            button
                                                            className="player-listitem"
                                                            onClick={this.handleSelectPlayer.bind(this, lineup, p)}
                                                            disabled={
                                                                status === BookingStatusType.Cancelled.ordinal ||
                                                                status === BookingStatusType.New.ordinal ||
                                                                !p.available
                                                            }
                                                        >
                                                            {p.profile && (
                                                                <Avatar aria-label={p.profile.firstName} src={image.getProfileImage(p.profile)} />
                                                            )}

                                                            {p.profile && (
                                                                <ListItemText
                                                                    primary={`${p.profile.firstName} ${p.profile.lastName}`}
                                                                    secondary={p.available ? "Available" : "Unavailable"}
                                                                />
                                                            )}
                                                            <ListItemSecondaryAction>
                                                                <Checkbox
                                                                    onChange={this.handleSelectPlayer.bind(this, lineup, p)}
                                                                    checked={p.profileId === lineup.profileId}
                                                                    disabled={
                                                                        status === BookingStatusType.Cancelled.ordinal ||
                                                                        status === BookingStatusType.New.ordinal ||
                                                                        !p.available
                                                                    }
                                                                />
                                                            </ListItemSecondaryAction>
                                                        </ListItem>
                                                    ) : (
                                                        ""
                                                    )
                                            )}
                                    </List>
                                </CardContent>
                            </Collapse>
                        )}
                </Card>
            </Grid>
        );
    };

    // {showRedirectLineUpModal} onClose={this.hideRedirectLineUpModal
    showRedirectLineUpModal = () => {
        this.setState({
            ...this.state,
            showRedirectModal: true
        });
    };

    hideRedirectLineUpModal = () => {
        this.setState({
            ...this.state,
            showRedirectModal: false
        });
    };

    showRedirectPromoteModal = () => {
        this.setState({
            ...this.state,
            showRedirectPromote: true
        });
    };

    hideRedirectPromoteModal = () => {
        this.setState({
            ...this.state,
            showRedirectPromote: false
        });
    };
    

    redirectNotifyClinet = () => {
        this.setState({
            ...this.state,
            showRedirectModal: false
        });
        this.props.redirectAction()
    }

    redirectPromote = () => {
        this.setState({
            ...this.state,
            showRedirectPromote: false
        });
        this.props.redirectActionPromote()
        
    }

    showNewLineupModal = () => {
        this.setState({
            ...this.state,
            showNewLineupModal: true
        });
    };

    hideNewLineupModal = () => {
        this.setState({
            ...this.state,
            showNewLineupModal: false
        });
    };

    renderAddLineupCard = () => {
        const { showNewLineupModal } = this.state;
         const {status,dateStart} = this.props.bookingRequestStore.booking;
         
        return (
            <Grid item xs={12} lg={3}>
               
               {
                 !(
                 status === BookingStatusType.Cancelled.ordinal) &&
                 <Tooltip id="tooltip-bottom" title="Add New Performer" placement="bottom">
                    <Card className="add-lineup-card" onClick={this.showNewLineupModal}>
                        <AddIcon />
                        <Typography color="primary" variant="headline" style={{ paddingTop: 3 }}>
                            Add New Performer
                        </Typography>
                    </Card>
                </Tooltip>
               }
              
                <NewLineupModal open={showNewLineupModal} onClose={this.hideNewLineupModal} />
            </Grid>
        );
    };

    
    
    showRemoveLineupConfirmation = lineup => {
        this.setState({
            ...this.state,
            showRemoveLineupConfirmation: true,
            deletedLineup: {
                lineup,
                profileId: lineup?.profileId,
                bookingId: this.props.bookingRequestStore.booking.id
            }
        });
    };

    hideRemoveLineupConfirmation = () => {
        this.setState({
            ...this.state,
            showRemoveLineupConfirmation: false,
            deletedLineup: undefined
        });
    };

     handleCloseReminder = (doNotShow) => {
        const { currentProfile } = this.props.profileStore;
        this.setState({
            ...this.state,
            closeReminder: true,
        });
        if(doNotShow){
           this.props.profileStore.setToggleAcknowledgeHirePayment(currentProfile?.id).then(() => {
                this.props.profileStore.loadProfiles().finally(() => {
                
                })
           })
        }
    };

    getPlayerCardData = (lineup, originalIndex) => {
        const { booking, percentageFeeSuper } = this.props.bookingRequestStore;
        const { currentProfile } = this.props.profileStore;
        const { lineups } = this.props.lineupStore;
        const { status } = booking;
        
        const currencySymbol = currentProfile?.currencySymbol || "$";
        const lineupsChanged = booking.lineups?.find(x => x.profileId === lineup.profileId);
        
        const lineupFee = parseFloat(lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? lineup.manualFee : lineup.fee);
        let superFee = 0;
        let invoiceAmountLineup = 0;
        
        if(!booking.isPayByActOwner && !booking.includeSuper) {
            superFee = superCalculationHelper.calculateSuperWithExclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper);
            invoiceAmountLineup = lineupFee;
        } else {
            superFee = superCalculationHelper.calculateSuperWithInclude(lineupFee, legalEntityHasSuper(lineup?.profile?.legalEntity) ? percentageFeeSuper : booking.percentageFeeSuper);
            if(booking.isPayByActOwner || booking.includeSuper){
                invoiceAmountLineup = parseFloat(lineupFee - (legalEntityHasSuper(lineup?.profile?.legalEntity) ? superFee : 0)).toFixed(2);
            } else {
                invoiceAmountLineup = parseFloat(lineupFee).toFixed(2);
            }
        }
        
        if(this.isActOwnerLineup(lineup) && booking.isPayByActOwner) {
            invoiceAmountLineup = parseFloat(lineupFee).toFixed(2);
            superFee = 0;
        }
        
        const isActAdmin = this.isActOwnerLineup(lineup);
        const isCompleted = status === BookingStatusType.Completed.ordinal;
        
        return {
            lineup,
            index: originalIndex,
            statusText: this.statusText(lineup, lineup.id, lineupsChanged),
            feeDisplay: `${currencySymbol} ${parseFloat(lineup.fee).toFixed(2)}`,
            superFeeDisplay: legalEntityHasSuper(lineup?.profile?.legalEntity) ? `${currencySymbol} ${superFee}` : "-",
            invoiceAmountDisplay: `${currencySymbol} ${invoiceAmountLineup}`,
            editMode: lineup.editMode || false,
            manualFee: lineup.manualFee,
            currencySymbol,
            rosters: (lineup.actRoster?.rosters || []).filter(player =>
                !(
                    booking.isPayByActOwner &&
                    player?.profile &&
                    this.isActOwnerLineup({ profileId: player.profile.id })
                )
            ),
            isActAdmin,
            isPayByActOwner: booking.isPayByActOwner,
            extraGigFee: parseFloat(this.getLineupExtraGigFee()),
            allLineupProfileIds: lineups
                .filter(l => !this.shouldExcludeActOwnerPlayer(l))
                .map(l => l.profileId),
            bookingStatus: status,
            isBookingCancelled: status === BookingStatusType.Cancelled.ordinal,
            isBookingNew: status === BookingStatusType.New.ordinal,
            showRemoveButton: !isActAdmin || !booking.isPayByActOwner,
            showEditButton: !(status === BookingStatusType.Cancelled.ordinal || status === BookingStatusType.New.ordinal || status === BookingStatusType.Hold.ordinal),
            onEdit: () => this.changeLineupEditMode(originalIndex),
            onFeeChange: (value) => this.handleSetManualRosterFee(value, originalIndex),
            onDone: () => this.doneLineupFeeEdit(originalIndex),
            onCancel: () => this.changeLineupEditMode(originalIndex),
            onRemove: () => this.showRemoveLineupConfirmation(lineup),
            onExpand: () => this.handleExpandClick(lineup),
            onSelectPlayer: (player) => this.handleSelectPlayer(lineup, player)
        };
    };

    calculateActOwnerBalance = () => {
        const { lineups } = this.props.lineupStore;
        const { booking } = this.props.bookingRequestStore;
        
        let totalPlayerFees = 0;
        lineups.forEach(lineup => {
            if (lineup.status !== LineupStatusType.Removed.ordinal && 
                !this.isActOwnerLineup(lineup)) {
                totalPlayerFees += lineup.manualFee === 0 ? lineup.manualFee : lineup.manualFee ? Number(lineup.manualFee) : Number(lineup.fee);
            }
        });
        var performanceFee = 0
        if(booking.isPayByActOwner && booking.isSuperFee){
            performanceFee = parseFloat(booking?.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee).toFixed(2)
            // superFeeExclude = !booking?.includeSuper
        }else{
            performanceFee = booking.actFee
            // superFeeExclude = !booking?.includeSuper
        }
        const balance = performanceFee - totalPlayerFees;
        return parseFloat(balance).toFixed(2);
    };

    getActAdminCardData = () => {
        const { booking } = this.props.bookingRequestStore;
        const { currentProfile } = this.props.profileStore;
        
        const currencySymbol = currentProfile?.currencySymbol || "$";
        const superFee = booking.includeSuper 
            ? superCalculationHelper.calculateSuperWithInclude(booking.actFee, booking.percentageFeeSuper) 
            : superCalculationHelper.calculateSuperWithExclude(booking.actFee, booking.percentageFeeSuper);
        const invoiceAmount = booking.includeSuper 
            ? parseFloat(parseFloat(booking.actFee) - parseFloat(superFee)).toFixed(2) 
            : parseFloat(booking.actFee).toFixed(2);
        
        return {
            actName: booking?.act?.actName || "-",
            adminName: `${currentProfile?.firstName} ${currentProfile?.lastName}`,
            adminProfile: currentProfile,
            performanceFee: parseFloat(booking.actFee).toFixed(2),
            superFee: parseFloat(superFee).toFixed(2),
            invoiceAmount,
            currencySymbol
        };
    };

    getUnifiedTablePlayerFee = (lineup) => {
        return lineup.manualFee !== undefined && lineup.manualFee !== null && lineup.manualFee !== "" 
            ? Number(lineup.manualFee) 
            : Number(lineup.fee) || 0;
    };

    getUnifiedTablePlayerSuper = (lineup) => {
        const { booking, percentageFeeSuper } = this.props.bookingRequestStore;
        const fee = this.getUnifiedTablePlayerFee(lineup);
        
        if (this.isActOwnerLineup(lineup) && booking.isPayByActOwner) {
            return 0;
        }
        
        if (!legalEntityHasSuper(lineup?.profile?.legalEntity)) {
            return 0;
        }
        
        if (!booking.isPayByActOwner && !booking.includeSuper) {
            return superCalculationHelper.calculateSuperWithExclude(fee, percentageFeeSuper || booking.percentageFeeSuper);
        } else {
            return superCalculationHelper.calculateSuperWithInclude(fee, percentageFeeSuper || booking.percentageFeeSuper);
        }
    };

    getUnifiedTablePlayerInvoice = (lineup) => {
        const { booking } = this.props.bookingRequestStore;
        const fee = this.getUnifiedTablePlayerFee(lineup);
        const superFee = this.getUnifiedTablePlayerSuper(lineup);
        
        if (this.isActOwnerLineup(lineup) && booking.isPayByActOwner) {
            return fee;
        }
        
        if (legalEntityHasSuper(lineup?.profile?.legalEntity)) {
            if (booking.isPayByActOwner || booking.includeSuper) {
                return parseFloat(fee - superFee).toFixed(2);
            }
        }
        return fee;
    };

    calculateUnifiedTableTotals = () => {
        const { lineups } = this.props.lineupStore;
        const { booking } = this.props.bookingRequestStore;
        
        let totalPlayerFees = 0;
        let totalSuper = 0;
        let totalInvoice = 0;
        
        for (let i = 0; i < lineups.length; i++) {
            const lineup = lineups[i];
            if (lineup.status !== LineupStatusType.Removed.ordinal) {
                if (booking.isPayByActOwner && this.isActOwnerLineup(lineup)) {
                    continue;
                }
                const fee = this.getUnifiedTablePlayerFee(lineup);
                const superFee = parseFloat(this.getUnifiedTablePlayerSuper(lineup)) || 0;
                const invoice = parseFloat(this.getUnifiedTablePlayerInvoice(lineup)) || 0;
                
                totalPlayerFees += fee;
                totalSuper += superFee;
                totalInvoice += invoice;
            }
        }
        var performanceFee = 0
        if(booking.isPayByActOwner && booking.isSuperFee){
            performanceFee = parseFloat(booking?.includeSuper ? superCalculationHelper.calculateFeeWithoutSuperWithInclude(booking.actFee, booking.percentageFeeSuper) : booking.actFee).toFixed(2)
            // superFeeExclude = !booking?.includeSuper
        }else{
            performanceFee = booking.actFee
            // superFeeExclude = !booking?.includeSuper
        }
        const actOwnerBalance = performanceFee - totalPlayerFees;
        const isOverBudget = totalPlayerFees > parseFloat(performanceFee);
        return {
            totalPlayerFees,
            totalSuper,
            totalInvoice,
            actOwnerBalance,
            isOverBudget,
            performanceFee
        };
    };

    handleUnifiedChangePlayer = (index, player) => {
        const { lineupStore } = this.props;
        const profile = player.fullProfile || player;
        lineupStore.changePlayerAtIndex(index, player.id || player.profileId, profile);
    };

    renderUnifiedTableLayout = () => {
        const { lineups } = this.props.lineupStore;
        const { booking } = this.props.bookingRequestStore;
        const { isAdmin, status, act, isPayByActOwner, actFee } = booking;
        const { currentProfile } = this.props.profileStore;
        const { showNewLineupModal } = this.state;
        
        const currencySymbol = currentProfile?.currencySymbol || "$";
        
        const filteredLineupsWithIndex = lineups
            .map((lineup, originalIndex) => ({ lineup, originalIndex }))
            .filter(item =>
                item.lineup.type === 0 &&
                item.lineup.status !== LineupStatusType.Removed.ordinal &&
                !this.shouldExcludeActOwnerPlayer(item.lineup)
            );
        
        const isBookingCancelled = status === BookingStatusType.Cancelled.ordinal;
        const isBookingNew = status === BookingStatusType.New.ordinal;
        const isBookingHold = status === BookingStatusType.Hold.ordinal;
        const canSave = !(isBookingCancelled || isBookingNew || isBookingHold) && isAdmin;
        
        const filteredLineup = lineups.filter(x => x.status !== LineupStatusType.Removed.ordinal);
        let isSoloAdminLineup = false;
        if (isPayByActOwner && act?.actAdminId == currentProfile?.id) {
            if (!filteredLineup || !filteredLineup.length) {
                isSoloAdminLineup = true;
            } else if (filteredLineup.length > 2) {
                isSoloAdminLineup = false;
            } else if (filteredLineup.length == 1) {
                isSoloAdminLineup = filteredLineup[0].profileId === currentProfile?.id;
            }
        }
        
        const totals = this.calculateUnifiedTableTotals();
        const isSaveDisabled = this.isLineupSaveButtonDisabled() || !canSave;

        const activeLineupProfileIds = filteredLineupsWithIndex.map(({ lineup }) => lineup.profileId);
        const isPlayerView = currentProfile?.id !== act?.actAdminId && activeLineupProfileIds.includes(currentProfile?.id);
        
        return (
            <div className="unified-lineup-wrapper">
                <UnifiedLineupTable
                    lineups={lineups}
                    filteredLineupsWithIndex={filteredLineupsWithIndex}
                    isAdmin={isAdmin}
                    isPayByActOwner={isPayByActOwner}
                    isSoloAdminLineup={isSoloAdminLineup}
                    canSave={canSave}
                    actFee={actFee}
                    currencySymbol={currencySymbol}
                    actOwnerBalance={totals.actOwnerBalance}
                    totalPlayerFees={totals.totalPlayerFees}
                    totalSuper={totals.totalSuper}
                    totalInvoice={totals.totalInvoice}
                    isOverBudget={totals.isOverBudget}
                    performanceFee={totals.performanceFee}
                    isSaveDisabled={isSaveDisabled}
                    actAdminId={act?.actAdminId}
                    bookingStatus={status}
                    showProductionCrew={SHOW_PRODUCTION_CREW}
                    isPlayerView={isPlayerView}
                    currentProfileId={currentProfile?.id}
                    onEditFee={(originalIndex) => this.changeLineupEditMode(originalIndex)}
                    onDoneEditFee={(originalIndex) => this.doneLineupFeeEdit(originalIndex)}
                    onCancelEditFee={(originalIndex) => this.changeLineupEditMode(originalIndex)}
                    onFeeChange={(value, originalIndex) => this.handleSetManualRosterFee(value, originalIndex)}
                    onChangePlayer={this.handleUnifiedChangePlayer}
                    onRemovePlayer={this.showRemoveLineupConfirmation}
                    onAddPerformer={this.showNewLineupModal}
                    onSave={this.handleSubmitForm}
                    getPlayerFee={this.getUnifiedTablePlayerFee}
                    getPlayerSuper={this.getUnifiedTablePlayerSuper}
                    getPlayerInvoice={this.getUnifiedTablePlayerInvoice}
                />
                
                {(currentProfile?.type === ProfileType.Musician.ordinal || currentProfile?.id == act?.actAdminId) && (
                    <LineupMessage bookingId={this.props.bookingId} />
                )}
                
                <NewLineupModal open={showNewLineupModal} onClose={this.hideNewLineupModal} />
            </div>
        );
    };

    renderCardsLayout = () => {
        const { lineups } = this.props.lineupStore;
        const { booking, percentageFeeSuper } = this.props.bookingRequestStore;
        const { isAdmin, status, act, isPayByActOwner } = booking;
        const { currentProfile } = this.props.profileStore;
        const { showNewLineupModal } = this.state;
        
        const currencySymbol = currentProfile?.currencySymbol || "$";
        
        const filteredLineup = lineups.filter(x => x.status !== LineupStatusType.Removed.ordinal);
        let isSoloAdminLineup = false;
        if(isPayByActOwner && act?.actAdminId === currentProfile?.id) {
            if(!filteredLineup || !filteredLineup.length) {
                isSoloAdminLineup = true;
            } else if(filteredLineup.length > 2) {
                isSoloAdminLineup = false;
            } else if(filteredLineup.length === 1) {
                isSoloAdminLineup = filteredLineup[0].profileId === currentProfile?.id;
            }
        }
        
        const filteredLineupsWithIndex = lineups
            .map((lineup, originalIndex) => ({ lineup, originalIndex }))
            .filter(item =>
                item.lineup.type === 0 &&
                item.lineup.status !== LineupStatusType.Removed.ordinal &&
                !this.shouldExcludeActOwnerPlayer(item.lineup)
            );
        
        const footerRow = isPayByActOwner 
            ? this.getLineupFooterRowsPayActOwner() 
            : this.getLineupFooterRows();
        
        const isBookingCancelled = status === BookingStatusType.Cancelled.ordinal;
        const isBookingNew = status === BookingStatusType.New.ordinal;
        const isBookingHold = status === BookingStatusType.Hold.ordinal;
        const canSave = !(isBookingCancelled || isBookingNew || isBookingHold) && isAdmin;
        
        return (
            <div className="lineup-cards-container">
                {isAdmin && isPayByActOwner && (
                    <div style={{ marginBottom: 24 }}>
                        <div className="lineup-cards-section-header">
                            <div>
                                <Typography variant="h6" className="lineup-cards-section-title">
                                    Act Owner Fee
                                </Typography>
                                <Typography variant="body2" className="lineup-cards-section-helper">
                                    This booking uses the "Invoiced by Act Owner" setting.
                                </Typography>
                            </div>
                        </div>
                        <ActAdminCard {...this.getActAdminCardData()} />
                    </div>
                )}
                
                {!isSoloAdminLineup && (
                    <>
                        <div className="lineup-cards-section-header" style={{ marginBottom: 20 }}>
                            <div>
                                <Typography variant="h6" className="lineup-cards-section-title">
                                    {isPayByActOwner ? "Line-up Player Fees" : "Players Line Up"}
                                </Typography>
                                <Typography variant="body2" className="lineup-cards-section-helper">
                                    {isPayByActOwner 
                                        ? "Allocate gig fee splits for each player in your line-up."
                                        : "Select and invite your players to this gig."
                                    }
                                </Typography>
                            </div>
                        </div>
                        
                        <div className="lineup-cards-layout">
                            <div className="lineup-cards-main">
                                <div className="lineup-cards-grid">
                                    {filteredLineupsWithIndex
                                        .map(({ lineup, originalIndex }) => (
                                            <PlayerCard 
                                                key={lineup.profileId || originalIndex}
                                                {...this.getPlayerCardData(lineup, originalIndex)}
                                            />
                                        ))
                                    }
                                    {isAdmin && (
                                        <AddPlayerCard 
                                            onClick={this.showNewLineupModal}
                                            disabled={isBookingCancelled}
                                        />
                                    )}
                                    {canSave && (
                                        <SaveButtonCard 
                                            onClick={this.handleSubmitForm}
                                            disabled={this.isLineupSaveButtonDisabled()}
                                        />
                                    )}
                                </div>
                            </div>
                            
                            <div className="lineup-cards-sidebar">
                                {footerRow && (
                                    <FeeSummaryPanel 
                                        footerRow={footerRow}
                                        title="Fee Summary"
                                        currencySymbol={currencySymbol}
                                        actOwnerBalance={isPayByActOwner ? this.calculateActOwnerBalance() : undefined}
                                    />
                                )}
                            </div>
                        </div>
                    </>
                )}
                
                {(currentProfile?.type === ProfileType.Musician.ordinal || currentProfile?.id == act?.actAdminId) && (
                    <LineupMessage bookingId={this.props.bookingId} />
                )}
                
                <NewLineupModal open={showNewLineupModal} onClose={this.hideNewLineupModal} />
            </div>
        );
    };

    renderTableLayout = () => {
        const { lineups } = this.props.lineupStore;
        const { isAdmin, status, act, isPayByActOwner } = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        
        const filteredLineup = lineups.filter(x => x.status !== LineupStatusType.Removed.ordinal);
        let isSoloAdminLineup = false;
        if(isPayByActOwner && act?.actAdminId === currentProfile?.id) {
            if(!filteredLineup || !filteredLineup.length) {
                isSoloAdminLineup = true;
            } else if(filteredLineup.length > 2) {
                isSoloAdminLineup = false;
            } else if(filteredLineup.length === 1) {
                isSoloAdminLineup = filteredLineup[0].profileId === currentProfile?.id;
            }
        }
        
        return (
            <Fragment>
                {isAdmin && isPayByActOwner ? (
                    <Grid container style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom>
                                    Act Owner Fee
                                </Typography>
                                <Typography gutterBottom className="side-helper-text">
                                    This booking uses the "Invoiced by Act Owner" setting.
                                    This section shows the act owner's fee, any applicable superannuation, and the total invoice amount payable to the act owner by the hirer
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={9}>
                            <ResponsiveTable columns={this.getFeeColumns()} rows={this.getFeeRow()} />
                        </Grid>
                    </Grid>
                ) : null}

                {!isSoloAdminLineup ? (
                    <Grid container style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            {isPayByActOwner ?
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom>
                                    Line-up Player Fees
                                </Typography>
                                <Typography gutterBottom className="side-helper-text">
                                    Use this section to allocate gig fee splits for each player in your line-up. You (the act owner) will receive invoices from each player and you'll be responsible for paying their superannuation where required.
                                </Typography> 
                            </div>:  
                                <div>
                                    <Typography variant="headline" component="h3" gutterBottom>
                                        Gig Fee Summary
                                    </Typography>
                                    <Typography gutterBottom className="side-helper-text">
                                        Use this section to distribute gig fees.
                                    </Typography>
                                </div>
                            }
                        </Grid>
                        {isPayByActOwner ? 
                            <Grid item xs={12} lg={9}>
                                <ResponsiveTable columns={this.getLineupColumns()} rows={this.getLineupRowsPayActOwner()} footerRow={this.getLineupFooterRowsPayActOwner()} />
                            </Grid>
                            : <Grid item xs={12} lg={9}>
                                <ResponsiveTable columns={this.getLineupColumns()} rows={this.getLineupRows()} footerRow={this.getLineupFooterRows()} />
                            </Grid>
                        }
                    </Grid>
                ) : null}

                {USE_NEW_LINEUP_UI ? null : (
                    <Grid container spacing={8} style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom>
                                    Players Line Up
                                </Typography>
                                <Typography gutterBottom className="side-helper-text">
                                    Select and invite your players to this gig.
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={9}>
                            <Grid container spacing={8}>
                                {lineups
                                    .filter(x =>
                                        x.type === 0 &&
                                        x.status !== LineupStatusType.Removed.ordinal &&
                                        !this.shouldExcludeActOwnerPlayer(x)
                                    )
                                    .map((lineup, index) => this.renderPlayerLineup(lineup, index))}
                                {isAdmin ? this.renderAddLineupCard() : null}
                            </Grid>
                        </Grid>
                    </Grid>
                )}

                {USE_NEW_LINEUP_UI ? null : SHOW_PRODUCTION_CREW ? (
                    <Grid container spacing={8} style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom>
                                    Production Crew
                                </Typography>
                                <Typography gutterBottom className="side-helper-text">
                                    Add support cast for your gig. Sound engineer, lighting engineer, MC, DJ, etc.
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={9}>
                            <Grid container spacing={8}>
                                {lineups.filter(x => x.type === 1).map((lineup, index) => this.renderProductionLineup(lineup, index))}
                            </Grid>
                        </Grid>
                    </Grid>
                ) : null}

                {USE_NEW_LINEUP_UI ? null : (
                    <Grid container style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            &nbsp;
                        </Grid>
                        <Grid item xs={12} lg={9}>
                            <Grid container spacing={8}>
                                <Grid item xs={12} lg={6} />
                                <Grid item xs={12} lg={6} />
                                <Grid item xs={12} lg={12}>
                                    <div className="action">
                                        {!(
                                            status === BookingStatusType.Cancelled.ordinal ||
                                            status === BookingStatusType.New.ordinal ||
                                            status === BookingStatusType.Hold.ordinal
                                        ) && isAdmin ? (
                                            <Fragment>
                                                <Tooltip
                                                    disableFocusListener={!this.isLineupSaveButtonDisabled()}
                                                    disableTouchListener={!this.isLineupSaveButtonDisabled()}
                                                    disableHoverListener={!this.isLineupSaveButtonDisabled()}
                                                    title="Roster's Fees is greater than Gig Fee"
                                                    placement="bottom-end"
                                                >
                                                    <span>
                                                        <Button
                                                            disabled={this.isLineupSaveButtonDisabled()}
                                                            variant="raised"
                                                            color="primary"
                                                            onClick={this.handleSubmitForm}
                                                        >
                                                            Save & Invite Players
                                                        </Button>
                                                    </span>
                                                </Tooltip>
                                            </Fragment>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Fragment>
        );
    };

    render() {
      
        // let NumberFormatCustom = props => {
        //     const { inputRef, onChange, ...other } = props;

        //     return (
        //         <NumberFormat
        //             {...other}
        //             ref={inputRef}
        //             onValueChange={values => {
        //                 onChange({
        //                     target: {
        //                         value: values.value
        //                     }
        //                 });
        //             }}
        //             thousandSeparator
        //             prefix="$"
        //         />
        //     );
        // };

        const { lineups, isLoadingLineup } = this.props.lineupStore;
        const { isAdmin, status, dateStart, act,isPayByActOwner } = this.props.bookingRequestStore.booking;
        const { currentProfile } = this.props.profileStore;
        const { lineUpBlock } = this.props.templateStore;
        const { showRemoveLineupConfirmation, showRedirectModal, showRedirectPromote } = this.state;

        var lineUps = lineups.filter(x => typeof x.id === "undefined")
        var isNotInvited = false
        if(lineups?.length > 1){
            isNotInvited = lineUps.length > 0;
        }else{
           
            if(lineUps.length && lineUps[0].profileId === currentProfile?.id){
                isNotInvited = false
            }else{
                isNotInvited = true
            }
        }
        
       

        if (isNotInvited && lineUps.length) {
            this.props.templateStore.closeLineupBlock();
        }
        else {
            this.props.templateStore.openLineupBlock();
        }
        var filtedLineup = lineups.filter(x=>x.status !== LineupStatusType.Removed.ordinal)
        var isSoloAdminLineup = false
        if(isPayByActOwner && act?.actAdminId == currentProfile?.id){
            if(!filtedLineup || !filtedLineup.length){
                isSoloAdminLineup = true
            }else if(filtedLineup.length > 2){
                isSoloAdminLineup = false
            }
            else if(filtedLineup.length == 1){
                isSoloAdminLineup = filtedLineup[0].profileId === currentProfile?.id
            }
        }
        return (
            <Grid container spacing={16} style={{ position: "relative", minHeight: "200px" }}>
                <ConfirmationModal
                    open={this.state.showNavigationModal}
                    title="Unsaved Changes"
                    message={this.state.navigationMessage}
                    confirmationLabel="Leave"
                    declineLabel="Stay"
                    confirmationHandler={this.handleNavigationConfirm}
                    declineHandler={this.handleNavigationCancel}
                    closeHandler={this.handleNavigationCancel}
                />
                
                <Loading showed={isLoadingLineup} />
                  {isAdmin && isPayByActOwner? (
                    <div className="unified-lineup-container" style={{ marginBottom: 24 }}>
                        <div className="unified-lineup-section-header">
                            <Typography className="unified-lineup-section-title">
                                Act Owner Fee
                            </Typography>
                            <Typography className="unified-lineup-section-subtitle">
                                This booking uses the "Invoiced by Act Owner" setting.
                                This section shows the act owner's fee, any applicable superannuation, and the total invoice amount payable to the act owner by the hirer
                            </Typography>
                        </div>
                        <div className="unified-lineup-table-container">
                            <table className="unified-lineup-table">
                                <thead>
                                    <tr>
                                        {this.getFeeColumns().filter(col => col.label).map(col => (
                                            <th key={col.key} style={{ width: col.width, background: "#ff0c9c", color: "#fff" }}>{col.label}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.getFeeRow().map((row, idx) => (
                                        <tr key={idx}>
                                            <td>{row.actName}</td>
                                            <td>{row.actAdmin}</td>
                                            <td>{row.fee}</td>
                                            <td>{row.superFee}</td>
                                            <td>{row.invoiceAmount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : null}

                {USE_NEW_LINEUP_UI ? (
                    <Grid item xs={12}>
                        {USE_UNIFIED_TABLE_UI ? this.renderUnifiedTableLayout() : this.renderCardsLayout()}
                    </Grid>
                ) : null}

                {USE_NEW_LINEUP_UI ? null : isAdmin && isPayByActOwner? (
                    <Grid container style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom>
                                    Act Owner Fee
                                </Typography>
                                <Typography gutterBottom className="side-helper-text">
                                    This booking uses the “Invoiced by Act Owner” setting.
                                    This section shows the act owner’s fee, any applicable superannuation, and the total invoice amount payable to the act owner by the hirer
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={9}>
                            <ResponsiveTable columns={this.getFeeColumns()} rows={this.getFeeRow()} />
                        
                        </Grid>
                    </Grid>
                ) : null}

                {USE_NEW_LINEUP_UI ? null : !isSoloAdminLineup ? (
                    <Grid container style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            {isPayByActOwner ?
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom>
                                    Line-up Player Fees
                                </Typography>
                                <Typography gutterBottom className="side-helper-text">
                                    Use this section to allocate gig fee splits for each player in your line-up. You (the act owner) will receive invoices from each player and you’ll be responsible for paying their superannuation where required.
                                </Typography> 
                                </div>:  
                                    <div>
                                        <Typography variant="headline" component="h3" gutterBottom>
                                            Gig Fee Summary
                                        </Typography>
                                        <Typography gutterBottom className="side-helper-text">
                                            Use this section to distribute gig fees.
                                        </Typography>
                                    </div>

                            }
                            
                        </Grid>

                        {
                            isPayByActOwner ? 
                                <Grid item xs={12} lg={9}>
                                <ResponsiveTable columns={this.getLineupColumns()} rows={this.getLineupRowsPayActOwner()} footerRow={this.getLineupFooterRowsPayActOwner()} />
                            </Grid>
                            : <Grid item xs={12} lg={9}>
                                <ResponsiveTable columns={this.getLineupColumns()} rows={this.getLineupRows()} footerRow={this.getLineupFooterRows()} />
                            </Grid>
                        }
                        
                    </Grid>
                ) : null}

                {USE_NEW_LINEUP_UI ? null : (
                    <Grid container spacing={8} style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom>
                                    Players Line Up
                                </Typography>
                                <Typography gutterBottom className="side-helper-text">
                                    Select and invite your players to this gig.
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={9}>
                            <Grid container spacing={8}>
                                {lineups
                                    .filter(x =>
                                        x.type === 0 &&
                                        x.status !== LineupStatusType.Removed.ordinal &&
                                        !this.shouldExcludeActOwnerPlayer(x)
                                    )
                                    .map((lineup, index) => this.renderPlayerLineup(lineup, index))}
                                {isAdmin ? this.renderAddLineupCard() : null}
                            </Grid>
                        </Grid>
                    </Grid>
                )}

                {USE_NEW_LINEUP_UI ? null : SHOW_PRODUCTION_CREW ? (
                    <Grid container spacing={8} style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            <div>
                                <Typography variant="headline" component="h3" gutterBottom>
                                    Production Crew
                                </Typography>
                                <Typography gutterBottom className="side-helper-text">
                                    Add support cast for your gig. Sound engineer, lighting engineer, MC, DJ, etc.
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={9}>
                            <Grid container spacing={8}>
                                {lineups.filter(x => x.type === 1).map((lineup, index) => this.renderProductionLineup(lineup, index))}
                            </Grid>
                        </Grid>
                    </Grid>
                ) : null}

                {USE_NEW_LINEUP_UI ? null : (
                    <Grid container style={{ paddingBottom: 60, backgroundColor: "#fff" }}>
                        <Grid item xs={12} lg={3}>
                            &nbsp;
                        </Grid>
                        <Grid item xs={12} lg={9}>
                            <Grid container spacing={8}>
                                <Grid item xs={12} lg={6} />
                                <Grid item xs={12} lg={6} />
                                <Grid item xs={12} lg={12}>
                                    <div className="action">
                                        {!(
                                            status === BookingStatusType.Cancelled.ordinal ||
                                            status === BookingStatusType.New.ordinal ||
                                            status === BookingStatusType.Hold.ordinal
                                        ) && isAdmin ? (
                                            <Fragment>
                                                <Tooltip
                                                    disableFocusListener={!this.isLineupSaveButtonDisabled()}
                                                    disableTouchListener={!this.isLineupSaveButtonDisabled()}
                                                    disableHoverListener={!this.isLineupSaveButtonDisabled()}
                                                    title="Roster's Fees is greater than Gig Fee"
                                                    placement="bottom-end"
                                                >

                                                    <span>
                                                        <Button
                                                            disabled={this.isLineupSaveButtonDisabled()}
                                                            variant="raised"
                                                            color="primary"
                                                            onClick={this.handleSubmitForm}
                                                        >
                                                            Save & Invite Players
                                                        </Button>
                                                    </span>
                                                </Tooltip>
                                            </Fragment>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {/* <RedirectLineUpModal open={showRedirectModal} onClose={this.hideRedirectLineUpModal} /> */}
                <ConfirmationModal
                    open={showRedirectModal}
                    title="Line Up Invited!"
                    message={`Your players have been invited. Would you like to notify the client?`}
                    closeHandler={this.hideRedirectPromoteModal}
                    confirmationHandler={this.redirectNotifyClinet}
                    declineHandler={this.hideRedirectLineUpModal}
                    confirmationLabel="Continue"
                />
                <ConfirmationModal
                    open={showRedirectPromote}
                    title="Post To Socials"
                    message={`Let people know about your gig by posting to your socials`}
                    closeHandler={this.hideRedirectPromoteModal}
                    confirmationHandler={this.redirectPromote}
                    declineHandler={this.hideRedirectPromoteModal}
                    confirmationLabel="Create Post"
                    declineLabel="Not now"
                />
                <ConfirmationModal
                    open={showRemoveLineupConfirmation}
                    title="Remove Lineup"
                    message={`Are you sure to remove lineup? `}
                    closeHandler={this.hideRemoveLineupConfirmation}
                    confirmationHandler={this.handleRemoveLineup}
                    declineHandler={this.hideRemoveLineupConfirmation}
                    confirmationLabel="Remove"
                />
                <ConfirmationModalCheckboxComponent
                    open={!this.state.closeReminder && !currentProfile?.hasAcknowledgeHirePayment && !isPayByActOwner && lineups?.length }
                    title="Invite Players Reminder"
                    message="Player invoices for this booking are paid by the hirer.  As such you need to add and invite your players to this gig in order for the your invoice, and the players invoices to be generated.   Add your players, edit the fee and click Save and Invite."
                    closeHandler={this.handleCloseReminder}
                    confirmationHandler={this.handleCloseReminder}
                    confirmationLabel="Close"
                    hideDecline={true}
                    maxWidth="sm"
                />   
            </Grid>
        );
    }
}

export default withRouter(BookingLineup);
